import { render } from "./NavigationContainer.vue?vue&type=template&id=53b7efed"
import script from "./NavigationContainer.vue?vue&type=script&lang=js"
export * from "./NavigationContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__